import { WHITELABEL_SETTINGS } from 'js/constants/config';
import { useMemo } from 'react';

export interface iWHITELABEL_SETTINGS {
  page: { title: string };
  brand: { logoMark: string; logoPortrait: string; logoLandscape: string };
  pagingMode: 'default' | 'sample-wl';
  mainContent: { bgColor: string };
  pipelines: { bgColor: string };
  tx: { hideGrp: string[] };
  header: {
    bgColor: string;
    navIconColor: string;
    avatarBgColor: string;
    avatarInitialsColor: string;
  };
  sidebar: {
    logo?: string;
    /**
     * Indicates the background-color for the nav-container
     */
    containerBgColor: string;
    iconColor: string;
    activeIconColor: string;
    itemContentColor: string;
    activeItemBg: string;
    activeItemHoverBg: string;
    rootItemHoverBg: string;
    activeMenuItemContentColor: string;
    activeCtaItemContentColor: string;
    /**
     * @SubMenu
     */
    submenuBg: string;
    submenuItemHoverBg: string;
  };
  palette: {
    '--color-primary-50': string;
    '--color-primary-100': string;
    '--color-primary-200': string;
    '--color-primary-300': string;
    '--color-primary-400': string;
    '--color-primary-500': string;
    '--color-primary-600': string;
    '--color-primary-700': string;
    '--color-primary-800': string;
    '--color-primary-900': string;
    '--color-secondary-50': string;
    '--color-secondary-100': string;
    '--color-secondary-200': string;
    '--color-secondary-300': string;
    '--color-secondary-400': string;
    '--color-secondary-500': string;
    '--color-secondary-600': string;
    '--color-secondary-700': string;
    '--color-secondary-800': string;
    '--color-secondary-900': string;
  };
}

export function useWhitelabelConfiguration(): iWHITELABEL_SETTINGS {
  return useMemo(() => WHITELABEL_SETTINGS, []);
}
